import { blankless } from '@js/dom/parent';

/*
 * `home-blank` NÃO É DESTINO, É CORTINA: a tela que terminou o trabalho emite a mensagem e
 * some, porque quem leva a pessoa ao próximo lugar é o host, e a tela que fica para trás não
 * pode continuar viva atrás da página que ele está trocando.
 *
 * QUANDO O HOST TROCA O DOCUMENTO A CORTINA VIRA UM PISCA. Entre a mensagem e a página nova
 * há um round trip de servidor, e nele a listagem sai da tela e entra
 * "204 - Nenhum conteúdo a ser exibido", até o navegador descartar o documento inteiro. Não
 * há tela velha a esconder - ela vai embora sozinha, com o documento -, então a navegação
 * não acontece e o que estava na tela fica lá até a página nova chegar.
 *
 * ABORTA A NAVEGAÇÃO EM VEZ DE CADA TELA NÃO PEDIR: o `push` sai de vinte e sete lugares e
 * quem decide isto é um fato do HOST, não de cada um deles. É o mesmo lugar que já escolhe o
 * history pelo `endpoint`.
 *
 * O EFEITO COLATERAL É DE DIAGNÓSTICO: host sem handler para a mensagem deixava a tela em
 * branco, que era o sintoma pelo qual se descobria a falta. Sob `document` o clique passa a
 * não fazer nada visível - continua sem erro no console, como sempre foi.
 */
export default function blank(to) {
  if (to.name !== 'home-blank') {
    return true;
  }

  return !blankless();
}
